<template>
  <v-app id="inspire" v-if="!signedIn || !googleSignedIn">
    <v-main>
      <v-container class="container-custom">
        <div align="center" style="padding-top: 90px;">
          <img
            src="@/assets/logo.svg"
            width="256"
            alt="Mail Switch logo"
            class="mb-3"
          />

          <h1 class="display-2 font-weight-medium">{{ title }}</h1>

          <p>You have to be signed in to use {{ title }}.</p>

          <v-alert
            width="60%"
            role="alert"
            type="error"
            v-if="message !== null"
          >
            {{ message }}
          </v-alert>
          <div
            :style="googleSignedIn ? 'pointer-events:none;opacity:0.4' : ''"
            id="buttonDiv"
            class="d-flex"
          ></div>
          <div v-if="googleSignedIn">
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </div>
      </v-container>
    </v-main>

    <error-snackbar></error-snackbar>
  </v-app>
</template>
<style>
.container-custom {
  max-width: 80%;
}

.app-title {
  height: 60px;
  display: flex;
  align-items: center;
}

.d-flex {
  align-items: center;
  justify-content: center;
}
</style>
<script>
import { routes } from "@/router/index.js";
import ErrorSnackbar from "@/components/ErrorSnackbar";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ErrorSnackbar,
  },

  data: () => ({
    drawer: null,
    title: process.env.VUE_APP_TITLE,
    message: null,
    routes,
  }),

  computed: {
    ...mapGetters({
      appName: "appName",
      googleSignedIn: "google/signedIn",
      signedIn: "user/signedIn",
      loading: "loading",
    }),

    navRoutes() {
      return this.routes.filter((v) => v.meta.nav);
    },
  },

  methods: {
    ...mapActions({
      signOut: "google/signOut",
      userSignOut: "user/userSignOut",
    }),
  },

  watch: {
    async googleSignedIn(v) {
      if (v) {
        this.message = null;
        try {
          await this.$store.dispatch("user/authenticate");
        } catch (e) {
          if (e && e.data) {
            this.$store.dispatch("error/handle", e);

            switch (e.data.detail) {
              case "not_admin":
                this.message =
                  "You must be signed in with a Google Workspace advanced administrator account.";
                break;
              case "invalid_token":
              case "invalid_api_call":
              default:
                this.message =
                  "Oops! Something went wrong. If this persists, contact Online Partner.";
                break;
            }
            await this.signOut();
            await this.userSignOut();
          }
        }
      }
    },
  },
};
</script>
